import { createProvider } from '@frontend/store';
import { PX_PER_MINUTE } from '../constants';
import {
  CalendarColumn,
  CalendarColumnGroup,
  CalendarEvent,
  CalendarColumnHeaderType,
  CalendarTimeIndicatorLines,
  CalendarColumnBodyVariant,
} from '../types';

type State = {
  headerType: CalendarColumnHeaderType;
  columnBodyVariant: CalendarColumnBodyVariant;
  groupIds: string[]; // keep this to maintain group order as we can't rely on object key order
  groupsById: Record<string, CalendarColumnGroup | undefined>;
  columnsById: Record<string, CalendarColumn | undefined>;
  eventsById: Record<string, CalendarEvent | undefined>;

  // derived state
  hasMultipleGroups: boolean; // can be used to determine if we need to show group headers, and also for some styling decisions
  canScrollLeft: boolean;
  canScrollRight: boolean;

  // other state
  pxPerMinute: number;
  timeIndicatorLines: CalendarTimeIndicatorLines;
};

type Actions = {
  setPxPerMinute: (px: number) => void;
  setTimeIndicatorLines: (interval: CalendarTimeIndicatorLines) => void;
};

export type CalendarGridStore = State & Actions;

export const {
  Provider: CalendarGridStoreProvider,
  useStore: useCalendarGridStore,
  useNonReactiveStore,
} = createProvider<CalendarGridStore>()((set) => ({
  headerType: 'default',
  columnBodyVariant: 'grid',
  groupIds: [],
  groupsById: {},
  columnsById: {},
  eventsById: {},

  hasMultipleGroups: false,
  canScrollLeft: false,
  canScrollRight: false,

  pxPerMinute: PX_PER_MINUTE,
  timeIndicatorLines: 'half-hourly',

  initWithMockData: () => {},

  setPxPerMinute: (px) => set({ pxPerMinute: px }),
  setTimeIndicatorLines: (timeIndicatorLines) => set({ timeIndicatorLines }),
}));
